import { mix } from "@chorda/core";
import { Icon } from "chorda-bulma";
export const FaIcon = (props) => {
    return mix(Icon, {
        templates: {
            icon: {
                css: 'fas',
                reactions: {
                    data: (next, prev) => ({ classes: { [next]: true, [prev]: false } })
                }
            }
        }
    }, props && {
        injections: {
            data: props.icon$
        }
    });
};
